import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isTemplateListLoading: false,
  templateList: [],

  isTemplateOverridesListLoading: false,
  templateOverridesList: [],

  currentTemplateLoading: false,
  currentTemplate: {},

  dotPhraseOverridesList: [],
  selectedDotPhraseOverrides: null,
  isDotPhraseOverridesListLoading: false,
  dotPhraseOverridesUpdateLoading: false,
  dotPhraseOverridesCreateLoading: false,
  dotPhraseOverridesDeleteLoading: false,
  childOrganizations: [],
  practitionersByOrgs: [],
  practitionersByOrgsLoading: false,
  encounterCSVTimezone: null,
  isEncounterCSVTimezoneLoading: false,
  bulkEncounterUploadHistory: [],
  bulkEncounterUploadHistoryLoading: false,
  templateOverridesDeleteLoading: false,
  templateAdminList: [],
  isTemplateAdminListLoading: false,
  templateAdminPlanList: [],
  isCreateEncountersOnBehalfOfLoading: false,
  createEncountersOnBehalfOf: true,
};

const settingsSlice = createSlice({
  name: 'settingsSlice',
  initialState,
  reducers: {
    templateListLoading: (state, { payload }) => {
      state.isTemplateListLoading = payload;
    },
    templateListSlice: (state, { payload }) => {
      state.templateList = payload;
    },
    templateOverridesListLoading: (state, { payload }) => {
      state.isTemplateOverridesListLoading = payload;
    },
    templateOverridesListSlice: (state, { payload }) => {
      state.templateOverridesList = payload;
    },
    currentTemplateLoadingSlice: (state, { payload }) => {
      state.currentTemplateLoading = payload;
    },
    currentTemplateSlice: (state, { payload }) => {
      state.currentTemplate = payload;
    },
    resetSummaryState: () => {
      return initialState;
    },
    dotPhraseOverridesListSlice: (state, { payload }) => {
      state.dotPhraseOverridesList = payload;
    },
    selectedDotPhraseOverridesSlice: (state, { payload }) => {
      state.selectedDotPhraseOverrides = payload;
    },
    dotPhraseOverridesListLoading: (state, { payload }) => {
      state.isDotPhraseOverridesListLoading = payload;
    },
    dotPhraseOverridesUpdateLoadingSlice: (state, { payload }) => {
      state.dotPhraseOverridesUpdateLoading = payload;
    },
    dotPhraseOverridesCreateLoadingSlice: (state, { payload }) => {
      state.dotPhraseOverridesCreateLoading = payload;
    },
    dotPhraseOverridesDeleteLoadingSlice: (state, { payload }) => {
      state.dotPhraseOverridesDeleteLoading = payload;
    },
    childOrganizationsSlice: (state, { payload }) => {
      state.childOrganizations = payload;
    },
    practitionersByOrgsSlice: (state, { payload }) => {
      state.practitionersByOrgs = payload;
    },
    practitionersByOrgsLoadingSlice: (state, { payload }) => {
      state.practitionersByOrgsLoading = payload;
    },
    getEncounterCSVTimezoneSlice: (state, { payload }) => {
      state.encounterCSVTimezone = payload;
    },
    getEncounterCSVTimezoneLoadingSlice: (state, { payload }) => {
      state.isEncounterCSVTimezoneLoading = payload;
    },
    bulkEncounterUploadHistorySlice: (state, { payload }) => {
      state.bulkEncounterUploadHistory = payload;
    },
    bulkEncounterUploadHistoryLoadingSlice: (state, { payload }) => {
      state.bulkEncounterUploadHistoryLoading = payload;
    },
    templateOverridesDeleteLoadingSlice: (state, { payload }) => {
      state.templateOverridesDeleteLoading = payload;
    },
    templateAdminListSlice: (state, { payload }) => {
      state.templateAdminList = payload;
    },
    templateAdminListLoadingSlice: (state, { payload }) => {
      state.isTemplateAdminListLoading = payload;
    },
    templateAdminPlanListSlice: (state, { payload }) => {
      state.templateAdminPlanList = payload;
    },
    createEncountersOnBehalfOfSlice: (state, { payload }) => {
      state.createEncountersOnBehalfOf = payload;
    },
    createEncountersOnBehalfOfLoadingSlice: (state, { payload }) => {
      state.isCreateEncountersOnBehalfOfLoading = payload;
    },
  },
});

const { actions, reducer } = settingsSlice;

export const {
  templateListLoading,
  templateListSlice,
  templateOverridesListLoading,
  templateOverridesListSlice,
  currentTemplateLoadingSlice,
  currentTemplateSlice,
  resetSummaryState,
  dotPhraseOverridesListSlice,
  selectedDotPhraseOverridesSlice,
  dotPhraseOverridesListLoading,
  dotPhraseOverridesUpdateLoadingSlice,
  dotPhraseOverridesCreateLoadingSlice,
  dotPhraseOverridesDeleteLoadingSlice,
  childOrganizationsSlice,
  practitionersByOrgsSlice,
  practitionersByOrgsLoadingSlice,
  getEncounterCSVTimezoneSlice,
  getEncounterCSVTimezoneLoadingSlice,
  bulkEncounterUploadHistorySlice,
  bulkEncounterUploadHistoryLoadingSlice,
  templateOverridesDeleteLoadingSlice,
  templateAdminListSlice,
  templateAdminListLoadingSlice,
  templateAdminPlanListSlice,
  createEncountersOnBehalfOfSlice,
  createEncountersOnBehalfOfLoadingSlice,
} = actions;

export default reducer;
